/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProgrammeDefaultsCategoryKey {
    KYC_SETTING = 'KYC_SETTING',
    INVESTOR_DATA_CUSTOM_FIELDS = 'INVESTOR_DATA_CUSTOM_FIELDS',
    VESTING_TERMS = 'VESTING_TERMS',
    MASTER_DOCUMENTS = 'MASTER_DOCUMENTS',
    TAX_AND_COMPLIANCE = 'TAX_AND_COMPLIANCE',
    EMAIL_TEMPLATES = 'EMAIL_TEMPLATES',
    EMAIL_REMINDERS = 'EMAIL_REMINDERS',
    MEMBERS = 'MEMBERS',
}
